import { api } from './exports';

export * from './methods';

export default api;
